import { usePathname } from 'next/navigation';

import { getSupportedLocations } from '@/modules/location/helpers';

export function useIsPDP() {
  const pathname = usePathname();
  const supportedLocations = getSupportedLocations(
    process.env.NEXT_PUBLIC_SUPPORTED_LOCATIONS || ''
  );

  return !!(
    pathname.match(
      '^/products/(?!(?:create)(?:/|\\?|$))([^/]+)/?(?:\\?.*)?$'
    ) ||
    supportedLocations.some((locale) =>
      pathname.match(
        `^/${locale}/products/(?!(?:create)(?:/|\\?|$))([^/]+)/?(?:\\?.*)?$`
      )
    )
  );
}
